import _axios from '@/plugins/axios';
import { UsersError } from '@/lib/Errors';

export default {
	async getInventoryItems () {
		const response = await _axios.get('inventory/item');
		if (response.data.resFlag) {
			return response.data.data;
		} else if (response.data.msg === 'No inventory items found.') {
			return [];
		}
		throw new UsersError('Error getting items!');
	},
	async getInventoryItemById (id) {
		const response = await _axios.get(`inventory/item/${id}`);
		if (response.data.resFlag) {
			return response.data.data;
		}
		throw new UsersError('Error getting item!');
	},
	async getInventoryItemStatusOptions () {
		const response = await _axios.get('inventory/item/getInventoryItemStatuses');
		if (response.data.resFlag) {
			return response.data.data;
		}
		throw new UsersError('Error getting item statuses!');
	},
	async getInventoryItemConditionOptions () {
		const response = await _axios.get('inventory/item/getInventoryItemConditions');
		if (response.data.resFlag) {
			return response.data.data;
		}
		throw new UsersError('Error getting item conditions!');
	},
	async addInventoryItem (body) {
		const response = await _axios.post('inventory/item', body);
		if (response.data.resFlag) {
			return response.data.data;
		}
		throw new UsersError('Error adding item!');
	},
	async editInventoryItem (body) {
		const response = await _axios.put(`inventory/item/${body.id}`, body);
		if (response.data.resFlag) {
			return response.data.data;
		}
		throw new UsersError('Error editing item!');
	},
	async deleteInventoryItem (id) {
		const response = await _axios.delete(`inventory/item/${id}`);
		if (response.data.resFlag) {
			return response.data.data;
		}
		throw new UsersError('Error deleting item!');
	},
};
